module.exports = __webpack_public_path__ + "static/media/sink.8055f255.svg";